/* Rockee Redd 2.0: cart drawer. Free shipping progress + a short list of add-ons. One upsell surface, nothing else. */
(function(){
  var d=document,el=d.getElementById('rr-cart-cfg');
  if(!el){return;}
  var cfg;
  try{cfg=JSON.parse(el.textContent);}catch(e){return;}
  var threshold=Math.round((parseFloat(cfg.threshold)||0)*100);
  var maxPrice=Math.round((parseFloat(cfg.addonMax)||25)*100);
  var handles=String(cfg.addons||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
  var cache={},timer;
  function money(c){return '$'+(c/100).toFixed(2);}
  function getProduct(h){
    if(cache[h]){return Promise.resolve(cache[h]);}
    return fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():{};}).then(function(p){cache[h]=p||{};return cache[h];}).catch(function(){return {};});
  }
  function addonRow(p,v){
    var row=d.createElement('div');row.className='rr-addon';
    if(p.featured_image){var img=d.createElement('img');img.src=p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=160';img.alt='';img.loading='lazy';img.width=52;img.height=64;row.appendChild(img);}
    var info=d.createElement('div');info.className='rr-addon__info';
    var t=d.createElement('a');t.href=p.url||('/products/'+p.handle);t.textContent=p.title;info.appendChild(t);
    var s=d.createElement('span');s.textContent=(v.title&&v.title!=='Default Title'?v.title+' \u00b7 ':'')+money(v.price);info.appendChild(s);
    row.appendChild(info);
    var b=d.createElement('button');b.type='button';b.setAttribute('data-rr-add',v.id);b.setAttribute('data-rr-url',p.url||('/products/'+p.handle));b.setAttribute('aria-label','Add '+p.title+' to cart');b.textContent='add';
    row.appendChild(b);
    return row;
  }
  function render(){
    var drawer=d.querySelector('cart-drawer');
    if(!drawer){return;}
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var inner=drawer.querySelector('.drawer__inner');
      if(!inner){return;}
      drawer.querySelectorAll('.rr-cart-mark,.rr-ship,.rr-addons').forEach(function(n){n.remove();});
      var mark=d.createElement('span');mark.className='rr-cart-mark';mark.hidden=true;inner.appendChild(mark);
      if(!cart.item_count){return;}
      var header=inner.querySelector('.drawer__header');
      if(threshold>0&&header){
        var left=threshold-cart.total_price;
        var ship=d.createElement('div');ship.className='rr-ship';ship.setAttribute('role','status');
        var p=d.createElement('p');
        if(left>0){p.appendChild(d.createTextNode('you are '));var st=d.createElement('strong');st.textContent=money(left);p.appendChild(st);p.appendChild(d.createTextNode(' away from free US shipping'));}
        else{var ok=d.createElement('strong');ok.textContent='free US shipping unlocked';p.appendChild(ok);}
        var track=d.createElement('div');track.className='rr-ship__track';
        var fill=d.createElement('span');fill.style.width=Math.max(4,Math.min(100,cart.total_price/threshold*100))+'%';
        track.appendChild(fill);ship.appendChild(p);ship.appendChild(track);
        header.insertAdjacentElement('afterend',ship);
      }
      var inCart={};
      cart.items.forEach(function(i){inCart[i.handle]=true;});
      var picks=handles.filter(function(h){return !inCart[h];}).slice(0,5);
      var list=drawer.querySelector('cart-drawer-items');
      if(!picks.length||!list){return;}
      Promise.all(picks.map(getProduct)).then(function(products){
        var rows=[];
        products.forEach(function(prod){
          if(rows.length>=2||!prod||!prod.variants||prod.requires_selling_plan){return;}
          var best=null;
          prod.variants.forEach(function(v){if(v.available&&v.price<=maxPrice&&(!best||v.price>best.price)){best=v;}});
          if(best){rows.push(addonRow(prod,best));}
        });
        if(!rows.length||drawer.querySelector('.rr-addons')){return;}
        var box=d.createElement('div');box.className='rr-addons';
        var h=d.createElement('p');h.className='rr-addons__title';h.textContent=cfg.addonTitle||'pairs well with your order';
        box.appendChild(h);
        rows.forEach(function(r){box.appendChild(r);});
        list.appendChild(box);
      });
    }).catch(function(){});
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(render,150);}
  function watch(){
    var drawer=d.querySelector('cart-drawer');
    if(!drawer||!('MutationObserver' in window)){return;}
    new MutationObserver(function(){if(!drawer.querySelector('.rr-cart-mark')){schedule();}}).observe(drawer,{childList:true,subtree:true});
  }
  render();
  watch();
})();
